
  document.addEventListener("turbo:load", function(event) {
    window.dataLayer = window.dataLayer || []
    function gtag(){dataLayer.push(arguments)}
    gtag('js', new Date())
    gtag('config', 'UA-134198747-2', {'page_location': event.detail.url})
  }, false)